import Paper from "./Paper";
import TextField from "./TextField";
import Button from "./Button";
import Switch from "./Switch";
import FormControlLabel from "./FormControlLabel";
import List from "./List";
import MenuItem from "./MenuItem";
import Select from "./Select";
import inputBase from "./InputBase";
import FormControl from "./FormControl";
import ControlLabel from "./ControlLabel";
import Popover from "./Popover";
import MuiAutoComplete from "./MuiAutoComplete";
import MuiTabs from "./MuiTabs";
import Card from "./Card";
import Checkbox from "./Checkbox";
import Accordion from "./Accordion";
import Chip from "./Chip";


export default function ComponentsOverrides(theme: any) {
  return {
    ...Paper(theme),
    ...TextField(theme),
    ...Button(theme),
    ...Switch(theme),
    ...FormControlLabel(theme),
    ...List(theme),
    ...MenuItem(theme),
    ...Select(theme),
    ...inputBase(theme),
    ...FormControl(theme),
    ...ControlLabel(theme),
    ...Popover(theme),
    ...MuiAutoComplete(theme),
    ...MuiTabs(theme),
    ...Card(),
    ...Checkbox(theme),
    ...Accordion(theme),
    ...Chip(theme),
  };
}
